import React from "react";
import styles from "./styles.module.scss";

const SensorSticker = ({ label }) => {
  return <div className={styles.sensor_sticker}>{label}</div>;
};

export default SensorSticker;
